export interface FaqItem {
  question: string;
  answer: string;
}

export const FAQ: FaqItem[] = [
  {
    question: 'Do I need a guide to go truffle hunting in Oregon?',
    answer:
      'For most visitors, yes. A guided operator has land access, a trained dog, and the local knowledge to find ripe truffles without damaging the forest. If you do not want to hunt, public events like the Oregon Truffle Festival and the PSU Farmers Market truffle stand are good alternatives.',
  },
  {
    question: 'Can I just dig for truffles in an Oregon forest on my own?',
    answer:
      'No. Many productive truffle patches are on private land or restricted public land. Digging without permission can damage the forest, hurt future truffle crops, and may be illegal. Book through a guide or attend a permitted public event instead.',
  },
  {
    question: 'When is the best time to plan a truffle trip?',
    answer:
      'Winter, from January through March, is the easiest time because public tours, festivals, and restaurant truffle dishes are most available. Late winter and spring can work for private outings and dog training, but the calendar is smaller and less predictable.',
  },
  {
    question: 'Where should I stay for a truffle weekend?',
    answer:
      'It depends on your trip. Eugene is best for the Oregon Truffle Festival and dog-training events. Newberg and McMinnville are the classic Willamette Valley weekend bases, with dining and guided hunts nearby. Portland works for city-base day trips into the foothills. Corvallis fits education and society events.',
  },
  {
    question: 'Do I get to keep the truffles I find?',
    answer:
      'Sometimes. Ask the operator before booking. Some guided hunts include a take-home truffle, others sell them separately, and others focus on the experience and education. The Fresh Truffle Marketplace and farm stands are the simplest way to buy fresh truffles directly.',
  },
  {
    question: 'Can I bring my own dog?',
    answer:
      'Some training events and workshops are designed for handlers and their dogs. Most guided hunts provide a trained dog team as part of the trip, so your own dog is not required. Check the event description or ask the operator.',
  },
  {
    question: 'What should I wear and bring?',
    answer:
      'Dress for rain and mud. Waterproof boots, rain pants or gaiters, warm layers, gloves, and a hat are the essentials. Most guides provide digging tools. Bring water, snacks, a small breathable container if you are taking truffles home, and a camera.',
  },
];
